import React, { FC } from "react";

import { castingSupported } from "../../service/cast-service";

interface Props {
  chromecast: boolean;
}

export const Chromecast: FC<Props> = ({ chromecast }) => {
  return (
    <>
      {chromecast && castingSupported() && (
        <google-cast-launcher
          aria-label="chromecast"
          role="button"
          tabIndex={0}
        />
      )}
    </>
  );
};
